import {gql} from "@apollo/client";

export const RequestAccountDeletion = gql`
    mutation RequestAccountDeletion {
        requestAccountDeletion {
            success
            message
        }
    }
`;
